import React, { useState } from "react";
import "./LoginCard.css";
import { login_user } from "../api/serverWrapper";
import UserSystemRole from "../componants/UserSystemRole";
import { saveData } from "../utils/localstorage_constants";
import {
  IS_LOGGED,
  USER_ID,
  USER_SYSTEM_ROLE,
  LOGIN_USER_DISTRICT_ID,
  USER_DATA,
} from "../utils/localstorage_variables";
import { useNavigate } from "react-router-dom";

const LoginCard = () => {
  let isUser = false;
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  

  const handleLogin = async () => {
    if (!phone || !password) {
      setMessage("Enter mobile number and password");
      return;
    }

    const user = { PhoneNumber: phone.trim(), Password: password };

    setLoading(true);
    try {
      let resp = await login_user(user);

      console.log("resp.data", resp.data);

      if (resp?.data?.isLoginPass) {
        let u = resp.data.user;
        if (u.SystemRole === UserSystemRole.ADMIN.id) {
          saveData(IS_LOGGED, true);
          saveData(USER_ID, u.UserId);
          saveData(USER_SYSTEM_ROLE, u.SystemRole);
          navigate("/", { replace: true });
          window.location.reload();
        } else {
          setMessage("Only Super Admin Can Login!");
        }
      } else {
        setMessage("User not registered. Please register...!");
      }
    } catch (err) {
      console.error(err);
      setMessage("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h2 className="login-title">Login </h2>

        <div className="inputs">
          <input
            className="pill-input"
            placeholder="Phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            inputMode="tel"
          />

          <input
            className="pill-input"
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <div className="btn-row">
          <button
            className="login-btn"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? "Logging..." : "Login"}
          </button>
        </div>

        {message && <div className="error-msg">{message}</div>}
      </div>
    </div>
  );
};

export default LoginCard;
